import { render, staticRenderFns } from "./charts.vue?vue&type=template&id=52121fb5&scoped=true&"
import script from "./charts.vue?vue&type=script&lang=js&"
export * from "./charts.vue?vue&type=script&lang=js&"
import style0 from "./charts.vue?vue&type=style&index=0&id=52121fb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52121fb5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52121fb5')) {
      api.createRecord('52121fb5', component.options)
    } else {
      api.reload('52121fb5', component.options)
    }
    module.hot.accept("./charts.vue?vue&type=template&id=52121fb5&scoped=true&", function () {
      api.rerender('52121fb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistic/order-count/modules/charts.vue"
export default component.exports